import Parts from '../../componnets/parts/Parts';
import './seminar.css'
export default function Seminar({setParts , parts}) {
    const partir = [
        { id: 1, video: 'http://dl.mahoganyacademy.de/seminar/27aban.mp4', time: 'سمینار' , description: 'بیست و هفتم آبان' },
        { id: 2, image: 'http://dl.mahoganyacademy.de/seminar/1.jpg', time: 'سمینار' , description: '' },
        { id: 2, video: 'http://dl.mahoganyacademy.de/seminar/5.mp4', time: 'سمینار' , description: '' },
        { id: 2, image: 'http://dl.mahoganyacademy.de/seminar/2.jpg', time: 'سمینار' , description: '' },
        { id: 2, image: 'http://dl.mahoganyacademy.de/seminar/3.jpg', time: 'سمینار' , description: '' },
        { id: 2, image: 'http://dl.mahoganyacademy.de/seminar/4.jpg', time: 'سمینار' , description: '' },
    ];
    const partnotir = [

    ];
    function changingports(){
        parts === 'ir' ? setParts('notir') : setParts('ir');
    }
    return (
        <div className="seminarpage">
            <div className='changeparts' style={{display: parts === '' ? 'none' : 'inline-block'}} onClick={changingports}>{parts === 'ir' ? 'خارجی' : 'داخلی'}</div>
            {parts === '' ? <Parts setParts={setParts} /> : 
                        <div className="seminarcontainer">
                            {parts === 'ir' ? 
                                                    partir.map((comp) => (
                                                        <div key={comp.id} className="seminaritem">
                                                            {comp.video ? <video src={comp.video} controls /> : <img src={comp.image} loading='lazy' alt={comp.description}></img>}
                                                            <h3>{comp.time}</h3>
                                                            <p>{comp.description}</p>
                                                        </div>
                                                    )) :
                                                    partnotir.map((comp) => (
                                                        <div key={comp.id} className="seminaritem">
                                                            {comp.video ? <video src={comp.video} controls /> : <img src={comp.image} loading='lazy' alt={comp.description}></img>}
                                                            <h3>{comp.time}</h3>
                                                            <p>{comp.description}</p>
                                                        </div>
                                                    ))}
                    </div>}
        </div>
    );
}